export const TeamChatReferencesRailTestIds = {
  ROOT: 'team-chat-references-rail.root',
  ITEM: 'team-chat-references-rail.item',
  CLEAR_BUTTON: 'team-chat-references-rail.clear-button',
};
